var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-page"},[_c('ArticleHeader',{attrs:{"article":_vm.article}}),_c('div',{staticClass:"article-main"},[_c('ArticleContent',{attrs:{"article":_vm.article}}),_c('ArticleSidebar',{attrs:{"article":_vm.article}})],1),_c('ArticleRelated',{attrs:{"article":_vm.article}}),_c('NewsletterCta')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }